<!--Embeds a pdf for users to view.-->

<template>
  <mdb-container>
    <mdb-row>
      <mdb-col v-if="block.value.type == 'pdf'">
        <div v-if="loading" class="w-100 position-absolute">
          <mdb-spinner />
        </div>
        <pdf :src="`${block.value.doc}`" @loaded="setVisible()" width="1000" height="1000"></pdf>
        <a :href="`${block.value.doc}`">
          <mdb-btn>Download PDF</mdb-btn>
        </a>
      </mdb-col>
      <mdb-col v-else>
        <h3>An invalid document has been entered. Contact your system administrator.</h3>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import pdf from "vue-pdf";
import { mdbContainer, mdbRow, mdbCol, mdbBtn, mdbSpinner } from "mdbvue";
export default {
  name: "document_embed",
  props: {
    block: Object,
  },
  data() {
    return {
      loading: true,
    };
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbSpinner,
    pdf,
  },
  methods: {
    setVisible() {
      this.loading = false;
    },
  },
};
</script>
